import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600" }, "アポ変数", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600 mt20" }, "フォーム変数", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600 mt20" }, "ブロック変数", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LblueListContent = _resolveComponent("LblueListContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appoVariables, (title, titleindex) => {
      return (_openBlock(), _createBlock(_component_LblueListContent, {
        key: `appo${titleindex}`,
        name: title,
        value: title,
        class: _normalizeClass(`fl mr10 mb10`),
        type: `underline`,
        display: true,
        showDeleteButton: false,
        onClickContent: ($event: any) => (_ctx.selectVariable(title))
      }, null, 8, ["name", "value", "onClickContent"]))
    }), 128)),
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formVariables, (title, titleindex) => {
      return (_openBlock(), _createBlock(_component_LblueListContent, {
        key: `form${titleindex}`,
        name: title,
        value: title,
        class: _normalizeClass(`fl mr10 mb10`),
        type: `underline`,
        display: true,
        showDeleteButton: false,
        onClickContent: ($event: any) => (_ctx.selectVariable(title))
      }, null, 8, ["name", "value", "onClickContent"]))
    }), 128)),
    _hoisted_4,
    _hoisted_5,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockVariables, (title, titleindex) => {
      return (_openBlock(), _createBlock(_component_LblueListContent, {
        key: `block${titleindex}`,
        name: title,
        value: title,
        class: _normalizeClass(`fl mr10 mb10`),
        type: `underline`,
        display: true,
        showDeleteButton: false,
        onClickContent: ($event: any) => (_ctx.selectVariable(title))
      }, null, 8, ["name", "value", "onClickContent"]))
    }), 128))
  ]))
}